import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import Scrollbars from "react-custom-scrollbars-2";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import WinterMaintenceUnitsPeriodTable from "./WinterMaintenceUnitsPeriodTable";
import { states } from "../../../reducers/queriesStates";
import { withWinterTimeRange } from "../../../shared/containers/containerWinterMaintenceTimeRange";
import getDates from "../../../shared/services/date.service";
import { codeCroupsFulName } from "./codeCroups";
import { Checkbox } from "@mui/material";
import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";
import Preloader from "../../../shared/items/static/preloader";

class WinterMaintenceCompaniesPeriodInfo extends Component {
  constructor(props) {
    super(props);

    this.state = { withTable: true };
  }

  componentRef = null;

  onCompaniesChangeHandler(id) {
    const { winterArea, winterAreasFilter, onSetWinterAreasFilter } = this.props;

    const filter = winterAreasFilter.map((x) => {
      if (x.winterAreaId === winterArea.id) {
        x.companyId = id;
      }

      return x;
    });

    onSetWinterAreasFilter(filter);
  }

  areaBox(area) {
    const { winterAreasFilter } = this.props;

    const winterAreaFilter = winterAreasFilter.filter((x) => {
      return x.winterAreaId === area.id;
    })[0];

    if (winterAreaFilter.parentCompanies.length === 0) {
      return null;
    }

    return (
      <div key={area.id} className={styles.areaContainer}>
        <div>{area.title}</div>
        <div>
          {area.parentCompanies.map((parentCompany) => {
            const isSome = winterAreaFilter.parentCompanies.some((x) => {
              return x === parentCompany.id;
            });

            return isSome ? this.parentCompanyBox(parentCompany, winterAreaFilter) : null;
          })}
        </div>
      </div>
    );
  }

  parentCompanyBox(parentCompany, winterAreaFilter) {
    return (
      <div key={parentCompany.id} className={styles.parentCompanyContainer}>
        <div>{parentCompany.title}</div>
        <div>
          {parentCompany.companies
            .filter((company) => {
              // if (winterAreaFilter.regionId !== null && winterAreaFilter.regionId !== company.region.id) {
              //   return false;
              // }

              if (winterAreaFilter.companyId !== null && winterAreaFilter.companyId !== company.id) {
                return false;
              }

              return true;
            })
            .map((company) => {
              return this.companyBox(company);
            })}
        </div>
      </div>
    );
  }

  companyBox(company) {
    const { withTable } = this.state;

    const {
      winterWithoutGroupsFilter,
      winterGroupsFilter,
      searchTermWinterUnit,
      rangeStartDate,
      rangeStartTime,
      rangeEndDate,
      rangeEndTime,
      timeCompaniesRoutesRequest,
      searchGeoZone,
    } = this.props;

    if (company.units.length === 0) {
      return null;
    }

    const isGroupView = (unitGroups, filterGroups) => {
      if (filterGroups.length === 0 || unitGroups.length === 0) return false;

      return unitGroups.some((unitGroup) => {
        return filterGroups.some((x) => {
          return x === unitGroup.id;
        });
      });
    };

    const units = company.units.filter((unit) => {
      if (unit.dataRoute === undefined) {
        return false;
      }

      if (searchTermWinterUnit.length > 3) {
        return unit.registerNumber !== null && unit.registerNumber.toLowerCase().includes(searchTermWinterUnit);
      }

      const inGroups = unit.groups.length > 0;

      if (isGroupView(unit.groups, winterGroupsFilter)) {
        return true;
      } else if (!inGroups && winterWithoutGroupsFilter) {
        return true;
      }

      return false;
    });

    if (units.length === 0) {
      return null;
    }

    let dumpCount = 0;
    let sandCount = 0;

    let dumpLineCount = 0;
    let sandLineCount = 0;

    let dumpWorkCount = 0;
    let sandWorkCount = 0;

    let distance = 0;
    let distanceDump = 0;
    let distanceSand = 0;

    units.forEach((unit) => {
      dumpCount += unit.isDumpSensor ? 1 : 0;
      sandCount += unit.isSandSensor ? 1 : 0;

      dumpLineCount += unit.isDumpSensor && unit.dataRoute.distance > 0;
      sandLineCount += unit.isDumpSensor && unit.dataRoute.distance > 0;

      dumpWorkCount += unit.isDumpSensor && unit.dataRoute.distanceDump1 > 0;
      sandWorkCount += unit.isDumpSensor && unit.dataRoute.distanceSand > 0;

      distance += unit.dataRoute !== undefined ? unit.dataRoute.distance : 0;
      distanceDump += unit.dataRoute !== undefined ? unit.dataRoute.distanceDump1 : 0;
      distanceSand += unit.dataRoute !== undefined ? unit.dataRoute.distanceSand : 0;
    });

    distance = Math.round((distance + Number.EPSILON) * 100) / 100;
    distanceDump = Math.round((distanceDump + Number.EPSILON) * 100) / 100;
    distanceSand = Math.round((distanceSand + Number.EPSILON) * 100) / 100;

    const start = getDates.getDateFormat9(getDates.concat(rangeStartDate, rangeStartTime));
    const end = getDates.getDateFormat9(getDates.concat(rangeEndDate, rangeEndTime));
    const timeRequst = getDates.getDateFormat8(timeCompaniesRoutesRequest);

    const getCountInGroups = (groupId = null) => {
      let countWork = 0;
      let count = 0;

      units
        .filter((unit) => {
          return unit.dataRoute !== undefined;
        })
        .forEach((unit) => {
          let isSome = false;

          if (groupId !== null) {
            isSome = unit.groups.some((x) => {
              return x.id === groupId;
            });
          } else {
            isSome = unit.groups.length === 0;
          }

          countWork += isSome && unit.dataRoute !== undefined && unit.dataRoute.distance !== 0 ? 1 : 0;
          count += isSome ? 1 : 0;
        });

      return {
        countWork,
        count,
      };
    };

    const getGroupsCount = () => {
      return winterGroupsFilter.map((x, index) => {
        const item = getCountInGroups(x);

        return (
          <div className={styles.tablePivotDataContainer} key={index}>
            <div>{codeCroupsFulName[x]}:</div>
            <div>
              {" "}
              Работали {item.countWork} из {item.count} шт.
            </div>
          </div>
        );
      });
    };

    const percent = distance / 100;
    const percentDump = Math.round((distanceDump / percent + Number.EPSILON) * 100) / 100;
    const percentSand = Math.round((distanceSand / percent + Number.EPSILON) * 100) / 100;

    return (
      <div key={company.id} className={styles.companyContainer}>
        <div>{company.title}</div>
        {searchGeoZone !== null ? (
          <div>
            <b>Фильтрация по геозоне</b>
          </div>
        ) : null}
        <div className={styles.companySensorCountContainer}>
          <div>
            Интервал данных: {start} - {end} (На состояние сервера: {timeRequst})
          </div>

          <div>
            <b>Транспортные средства</b>
          </div>
          <div className={styles.tablePivotDataContainer}>
            <div>Всего:</div>
            <div>
              Работали{" "}
              {
                units.filter((x) => {
                  return x.dataRoute !== undefined && x.dataRoute.distance !== 0;
                }).length
              }{" "}
              из {units.length} шт.
            </div>
          </div>

          <div>{getGroupsCount()}</div>

          {winterWithoutGroupsFilter ? (
            <div className={styles.tablePivotDataContainer}>
              <div>Вне подгрупп:</div>
              <div>
                Работали {getCountInGroups().countWork} из {getCountInGroups().count} шт.
              </div>
            </div>
          ) : null}

          <div>
            <b>Пробег</b>
          </div>

          <div className={styles.tablePivotDataContainer}>
            <div>Всего:</div>
            <div>{distance} км.</div>
          </div>

          <div>
            <b>Датчики отвала:</b>
          </div>

          <div className={styles.tablePivotDataContainer}>
            <div>TC на линии:</div>
            <div>
              {dumpLineCount} из {dumpCount}
            </div>
          </div>

          <div className={styles.tablePivotDataContainer}>
            <div>Датчиков работало:</div>
            <div>
              {dumpWorkCount} из {dumpLineCount}
            </div>
          </div>

          <div className={styles.tablePivotDataContainer}>
            <div>Пробег:</div>
            <div>
              {distanceDump} км. ({percentDump} %)
            </div>
          </div>

          <div>
            <b>Датчики посыпки:</b>
          </div>

          <div className={styles.tablePivotDataContainer}>
            <div>TC на линии:</div>
            <div>
              {sandLineCount} из {sandCount}
            </div>
          </div>

          <div className={styles.tablePivotDataContainer}>
            <div>Датчиков работало:</div>
            <div>
              {sandWorkCount} из {sandLineCount}
            </div>
          </div>

          <div className={styles.tablePivotDataContainer}>
            <div>Пробег:</div>
            <div>
              {distanceSand} км. ({percentSand} %)
            </div>
          </div>
        </div>

        {withTable ? <WinterMaintenceUnitsPeriodTable units={units} /> : null}
      </div>
    );
  }

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  reactToPrintContent = () => {
    return this.componentRef;
  };

  reactToPrintTrigger = () => {
    return (
      <div style={{ width: "180px", marginBottom: "10px" }}>
        <ButtonPrimary>
          <PrintIcon /> <span>На печать</span>
        </ButtonPrimary>
      </div>
    );
  };

  downloadEOSKReport() {
    const {
      winterAreas,
      winterWithoutGroupsFilter,
      winterAreasFilter,
      winterGroupsFilter,
      onWinterEOSKReportDownload,
      rangeStartDate,
      rangeStartTime,
      rangeEndDate,
      rangeEndTime,
      searchGeoZone,
      winterSensorsFilter,
      regionTitle,
    } = this.props;
    const { withTable } = this.state;

    const options = {
      withTable,
      searchGeoZone,
      regionTitle,
      startDate: getDates.concat(rangeStartDate, rangeStartTime),
      endDate: getDates.concat(rangeEndDate, rangeEndTime),
      timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      sensorFilter: {
        dump1: winterSensorsFilter.filterDump1,
        dump2: winterSensorsFilter.filterDump2,
        sand: winterSensorsFilter.filterSand,
      },
      winterGroupFilter: {
        withoutGroups: winterWithoutGroupsFilter,
        groups: winterGroupsFilter,
      },
      winterAreaFilters: winterAreas.map((area) => {
        const winterAreaFilter = winterAreasFilter.filter((x) => {
          return x.winterAreaId === area.id;
        })[0];

        return {
          id: area.id,
          regionId: winterAreaFilter.regionId,
          parentCompanies: area.parentCompanies.map((parentCompany) => {
            return {
              id: parentCompany.id,
              winterCompanies: parentCompany.companies
                .filter((company) => {
                  return winterAreaFilter.companyId === null || winterAreaFilter.companyId === company.id;
                })
                .map((company) => {
                  return company.id;
                }),
            };
          }),
        };
      }),
    };

    onWinterEOSKReportDownload(options);
  }

  render() {
    const { openCompaniesInfoState, winterAreas, winterCompaniesRoutesDataState, winterEOSKReportDownloadDataStrate, searchGeoZone } =
      this.props;
    const { withTable } = this.state;

    if (openCompaniesInfoState !== 2) return null;
    if (winterCompaniesRoutesDataState !== states.READY) return;

    return (
      <div className={styles.winterMaintenceCompaniesInfoContainer}>
        <div className={styles.fieldContainer}>
          <div>
            <ReactToPrint
              content={this.reactToPrintContent}
              documentTitle="Списки компаний и их ТС зимнего содержания дорог"
              removeAfterPrint
              trigger={this.reactToPrintTrigger}
            />

            <Checkbox
              checked={withTable}
              onChange={(e) => {
                this.setState({ withTable: !withTable });
              }}
              style={{
                padding: "0px",
                transform: "scale(1)",
              }}
            />
            <span> Отображать таблицы</span>
          </div>
          <div>
            {winterEOSKReportDownloadDataStrate !== states.REQUEST ? (
              <ButtonIconWrapper type={"primary"} icon="save" handleClick={this.downloadEOSKReport.bind(this)} />
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Preloader />
              </div>
            )}
          </div>
        </div>

        <div>
          <Scrollbars ref="scrollbar" style={{ height: "calc(100vh - 155px)" }} autoHide={false}>
            <div ref={this.setComponentRef}>
              {winterAreas.map((area) => {
                return this.areaBox(area);
              })}
            </div>
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default withWinterTimeRange(withWinterMaintence(React.memo(WinterMaintenceCompaniesPeriodInfo)));
